import React, { HTMLAttributes, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import Header from '@components/Header'
import Footer from '@components/Footer'
import { above } from '@styles/mixins/breakpoints'

export interface ILayoutProps extends HTMLAttributes<HTMLDivElement> {
  contacts?: ReactNode
  contractHref: string
  formRef: React.RefObject<HTMLDivElement>
}

const SMain = styled.main`
  overflow: hidden;
  scroll-behavior: smooth;
  padding-top: 102px;
  ${above('md')(css`
    padding-top: 63px;
  `)}
  ${above('xl')(css`
    padding-top: 116px;
  `)}
`

const Layout: React.FC<ILayoutProps> = ({ children, contacts, contractHref, formRef, ...rest }) => {
  return (
    <div {...rest}>
      <Header contacts={contacts} contractHref={contractHref} />
      <SMain>{children}</SMain>
      <Footer formRef={formRef} />
    </div>
  )
}

export default Layout
